import type { Category, RegionOption, YearOption } from '@/types/movie';

export const categories: Category[] = [
  { key: 'action', name: '动作', desc: '拳拳到肉的热血追逐与硬核打斗，为肾上腺素而生。', icon: 'ri-sword-line' },
  { key: 'comedy', name: '喜剧', desc: '轻松解压的欢笑时刻，适合全家一起观看。', icon: 'ri-emotion-laugh-line' },
  { key: 'drama', name: '剧情', desc: '细腻深刻的人物故事，照见现实与人心。', icon: 'ri-book-open-line' },
  { key: 'scifi', name: '科幻', desc: '想象未来的无限可能，探索宇宙与科技边界。', icon: 'ri-planet-line' },
  { key: 'romance', name: '爱情', desc: '关于心动、错过与重逢的温柔叙事。', icon: 'ri-heart-3-line' },
  { key: 'thriller', name: '悬疑', desc: '层层反转与烧脑谜题，悬念直到最后一秒。', icon: 'ri-movie-2-line' },
  { key: 'animation', name: '动画', desc: '天马行空的想象力，献给所有年龄的童话。', icon: 'ri-magic-line' },
  { key: 'adventure', name: '冒险', desc: '踏上未知旅程，在广阔天地间寻找答案。', icon: 'ri-compass-3-line' },
];

export const regions: RegionOption[] = [
  { key: '国产', name: '国产' },
  { key: '欧美', name: '欧美' },
  { key: '日韩', name: '日韩' },
];

export const years: YearOption[] = [
  { key: 'recent5', name: '近5年' },
  { key: 'classic', name: '更早经典' },
];